<div *ngIf="room"
     [@slideFromBotOutside]="{value:'slideFromBotOutside', params:{bottom_value: isMobile ? '30px' : '20px'}}"
     [ngClass]="{'isMobile': isMobile}" class="activeCardContainer pointer">
  <div class="activeCard col-12 row p-0 overflow-hidden">

    <div class="col-5 col-md-6 p-0 position-relative">
      <app-accommodation-photo
        *ngIf="room && room['property_photos'] && room['property_photos'].length > 0"
        [checkForUpdates]="forceUpdate"
        [currentId]="room.id" [hasSmallBtn]="true"
        [propertyPhotos]="room['property_photos']"
        [room]="room"></app-accommodation-photo>
      <button (click)="$event.stopPropagation();closeActiveCard()" class="btn position-absolute p-0 border-0"
              type="button">
        <span aria-hidden="true" class="lh-1">&times;</span>
      </button>
      <app-item-badges [element]="room" *ngIf="room.badges"></app-item-badges>
    </div>

    <div class="col-7 col-md-6 specs d-flex flex-column font-12">

      <div class="d-flex gap-8">
        <div class="roomName text_4 mb-3 overflow-hidden">
          {{room.name}}
        </div>
        <app-btn-favorite [checkForUpdates]="forceUpdate" [favoritList]="favList"
          [item]="room" noFavIcon="fav4" [propertyPage]="false"
          (changedFavorite)="changeFavorite($event)"></app-btn-favorite>
      </div>

      <div class="d-flex flex-column pb-3 txt-darkGray minitext_3">

        <span class="pb-1">
          {{ "PROCESSES.ACCOMMODATION.LIST.MINIMUM_RENTAL" | translate:{value: room['minimal_stay_duration']} }}
        </span>

        <span *ngIf="room['disponibility']">
          {{ "PROCESSES.ACCOMMODATION.LIST.DISPONIBILITY_DATE" | translate }}
          {{ (room['disponibility'].replace(' ', 'T')) | date:'shortDate':'':locale }}
        </span>
      </div>

      <div class="d-flex gap-5px align-items-end mt-auto">
        <span class="price title_4 lh-1"> {{ (room.property_price.price | number: '1.0-0') + " €" }} </span>
        <span class="lh-1 minitext_3 txt-darkGray"> {{ "COMMON.PER_MONTH" | translate }}</span>
      </div>

    </div>
  </div>
</div>
